<template>
  <div
    class="phone-input input-component field"
    :class="{
      hovered: isHovered,
      focused: isFocused,
    }"
  >
    <label v-if="!!label" class="label ml-3">{{ label }}</label>
    <div
      class="is-flex"
      @mouseover="() => (isHovered = true)"
      @mouseleave="() => (isHovered = false)"
    >
      <div class="select-input" :class="small ? 'is-small' : 'bigger'">
        <select id="select" class="mt-0" v-model="phone_ddi">
          <option
            v-for="country in COUNTRIES"
            :key="country.code"
            :value="country.dial_code"
          >
            {{ `${country.dial_code} ${country.flag}` }}
          </option>
        </select>
      </div>
      <AppInput
        :value="value"
        v-mask="
          phone_ddi == '+55'
            ? ['(##) ####-#####', '(##) # ####-####']
            : '###############'
        "
        placeholder="(00) 0 0000-0000"
        type="tel"
        :required="required"
        :small="small"
        @input="(value) => $emit('input', value)"
        :onFocus="() => (isFocused = true)"
        :onBlur="() => (isFocused = false)"
      >
      </AppInput>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";

import AppInput from "components/ui/AppInput.vue";
import { mask } from "vue-the-mask";
import { COUNTRIES } from "utils/countries";

export default {
  directives: {
    mask,
  },
  components: {
    AppInput,
  },
  props: {
    label: String,
    value: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input"],
  setup(props) {
    const phone_ddi = ref("+55");
    const isFocused = ref(false);
    const isHovered = ref(false);

    return {
      phone_ddi,
      COUNTRIES,
      isFocused,
      isHovered,
    };
  },
};
</script>
<style scoped>
.phone-input span {
  font-size: 0.875rem;
}

.phone-input #select {
  border-radius: 0.5rem 0 0 0.5rem;
  min-height: 100%;
  width: 5.5rem;
  color: #262422;
  border-right: none;
}

.phone-input .is-small {
  height: 2.5rem;
  font-size: 0.825rem;
}

.phone-input :deep(.input-component) {
  width: 100%;
}

.phone-input :deep(.input) {
  border-radius: 0 0.5rem 0.5rem 0;
}
</style>
